import { createContext } from 'react';

const deviceProfileContext = createContext();

export default deviceProfileContext;